import React, { Component } from 'react';
import {connect} from "react-redux";
import HBIndexChartComponent from "./hb-index-chart-component";
import withFilters from "../../hoc/with-filters/with-filters-hoc";
import {changeRadio, clearData, loadHbIndexChartDataRequest} from "./hb-index-chart-action-creators";

class HBIndexChartContainer extends Component {


  componentDidMount() {
    const { filtersLoaded, loadData } = this.props;
    filtersLoaded ? loadData() : null;
  }

  componentDidUpdate(prevProps) {
    const { filtersLoaded, loadData } = this.props;
    !prevProps.filtersLoaded && filtersLoaded ? loadData() : null;
  }

  componentWillUnmount() {
    this.props.clearData();
  }

  render() {
    return (
      <HBIndexChartComponent
        {...this.props}
      />
    )
  }
}


const mapStateToProps = state => ({
  filtersLoaded: state.filters.loaded,
  data: state.hbIndexChart.data,
  radio: state.hbIndexChart.radio,
  selectedRadio: state.hbIndexChart.selectedRadio,
  error: state.hbIndexChart.error,
  loading: state.hbIndexChart.loading
});


const mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(loadHbIndexChartDataRequest()),
  changeRadio: radio => dispatch(changeRadio(radio)),
  clearData: () => dispatch(clearData())
});

export default withFilters(connect(mapStateToProps, mapDispatchToProps)(HBIndexChartContainer));


// WEBPACK FOOTER //
// ./src/modules/hb-index-chart/hb-index-chart-container.js